import React, { useRef } from "react";
import CommonCard from "./CommonCard";

import BarGraphSVG from "../../../../Shared/svg/bargraphSVG";
import RupeeSVGnew from "../../../../Shared/svg/rupeeSVGnew";
import SubscriptionSVG from "../../../../Shared/svg/subscriptionSVG";
import TickSVGnew from "../../../../Shared/svg/tickSVGnew";
import { roundDecimalWithComma } from "../../../../utils/updateAmount";

function MultipurposeCard({
  purpose,
  tranxnVolume,
  productCount,
  availableBalance,
  latestApprovedProd,
}: {
  purpose: string;
  tranxnVolume?: any;
  productCount?: any;
  availableBalance?: any;
  latestApprovedProd?: any;
}) {
  const tranxnVolumeRef = useRef(null);
  return (
    <>
      {purpose === "trans_info" && (
        <CommonCard
          icon={<BarGraphSVG />}
          title="Transaction Volume"
          value={tranxnVolume}
          buttonText="View Reports"
          ref={tranxnVolumeRef}
          buttonId="dashboard-view-reports"
          buttonTo="/application/reports"
        />
      )}
      {purpose === "subscription_info" && (
        <CommonCard
          icon={<SubscriptionSVG />}
          title="Products Subscribed"
          value={productCount}
          buttonText="More Products"
          buttonId="dashboard-more-products"
          buttonTo="/application/manage-apps"
        />
      )}

      {purpose === "avl_balance_info" && (
        <CommonCard
          icon={<RupeeSVGnew />}
          title="Available Balance"
          value={
            isNaN(availableBalance)
              ? "NA"
              : roundDecimalWithComma(availableBalance)
          }
          buttonText="Add Balance"
          buttonId="dashboard-add-balance"
          buttonTo="/application/billing"
        />
      )}
      {purpose === "trial_info" && (
        <CommonCard
          icon={<TickSVGnew />}
          title="Trial Approved"
          value={latestApprovedProd}
          buttonText="Begin Trial"
          buttonId="dashboard-begin-trial"
          buttonTo="/application/trial-center"
        />
      )}
    </>
  );
}

export default MultipurposeCard;
